<script>
import Layout from "@/router/layouts/main";
import { VclList } from "vue-content-loading";
import Stat from "@/components/widgets/stat";
import StatusBadge from "@/components/energia/StatusBadge.vue";
import { api } from "@/state/services";
import { formatCpfCnpjDisplay } from "@/utils/energia/cpfCnpj";
import { formatDateBR } from "@/utils/energia/dates";

export default {
  components: { Layout, VclList, Stat, StatusBadge },

  data() {
    return {
      clientes: [],
      loading: false,
      filtros: {
        busca: '',
        status: '',
      },
      fields: [
        { key: 'name', label: 'Cliente', sortable: true },
        { key: 'email', label: 'Contato', sortable: true },
        { key: 'date_added', label: 'Data', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'acoes', label: 'Ações', sortable: false, thClass: 'text-right', tdClass: 'text-right' },
      ],
      sortBy: 'name',
      sortDesc: false,
      currentPage: 1,
      perPage: 25,
    }
  },

  computed: {
    clientesFiltrados() {
      return this.clientes.filter(c => {
        const busca = this.filtros.busca.toLowerCase()
        const matchBusca = !busca ||
          (c.name || '').toLowerCase().includes(busca) ||
          (c.person_number || '').includes(busca) ||
          (c.email || '').toLowerCase().includes(busca)
        const matchStatus = !this.filtros.status || c.status === this.filtros.status
        return matchBusca && matchStatus
      })
    },

    kpis() {
      const todos = this.clientes
      return [
        { icon: 'bx bx-group', title: 'Total', value: String(todos.length) },
      ]
    },
  },

  mounted() {
    this.carregarDados()
  },

  methods: {
    formatCpfCnpjDisplay,
    formatDateBR,
    carregarDados() {
      this.loading = true
      api
        .get('energy/clients')
        .then(response => {
          if (response.data.status === 'success') {
            this.clientes = response.data.list || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    limparFiltros() {
      this.filtros = { busca: '', status: '' }
    },

    onRowClienteClick(item, _index, event) {
      if (event && event.target && event.target.closest('a, button, .btn')) {
        return
      }
      this.$router.push(`/energia/clientes/${item.id}`)
    },
  },

  watch: {
    filtros: {
      deep: true,
      handler() {
        this.currentPage = 1
      },
    },
  },
}
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item">Energia</li>
      <li class="breadcrumb-item active">Clientes</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Clientes</h3>
        <p></p>
      </div>
      <div>
        <router-link to="/energia/novo" class="btn btn-primary btn-block">
          <i class="bx bx-plus mr-1"></i> Novo cliente
        </router-link>
      </div>
    </div>

    <div class="row mb-3">
      <div v-for="kpi in kpis" :key="kpi.title" class="col-md-3">
        <Stat type="line" :icon="kpi.icon" :title="kpi.title" :value="kpi.value" />
      </div>
    </div>

    <div class="d-none card mb-3">
      <div class="card-body py-3">
        <div class="row">
          <div class="col-md-8 mb-2 mb-md-0">
            <input
              v-model="filtros.busca"
              type="text"
              class="form-control"
              placeholder="Buscar por nome, CPF, CNPJ ou e-mail..."
            />
          </div>
          <div class="col-md-3 mb-2 mb-md-0">
            <select v-model="filtros.status" class="form-control">
              <option value="">Todos os status</option>
              <option value="open">Em aberto</option>
              <option value="pending">Pendente</option>
              <option value="approved">Aprovado</option>
              <option value="ineligible">Inelegível</option>
              <option value="nonconformities">Triagem</option>
            </select>
          </div>
          <div class="col-md-1">
            <button class="btn btn-secondary p-2" @click="limparFiltros">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                <path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="loading">
          <vcl-list class="col-lg-6"></vcl-list>
        </div>

        <div v-else-if="!clientesFiltrados.length" class="text-center py-5">
          <i class="bx bx-user-x font-size-48 text-muted d-block mb-3"></i>
          <h5 class="text-muted">Nenhum cliente encontrado</h5>
          <p class="text-muted mb-3">Tente ajustar os filtros ou cadastre um novo cliente.</p>
          <router-link to="/energia/novo" class="btn btn-primary btn-sm">
            <i class="bx bx-plus mr-1"></i> Novo cliente
          </router-link>
        </div>

        <div v-else>
          <div class="table-responsive">
            <b-table
              :items="clientesFiltrados"
              :fields="fields"
              class="table-nowrap table-style table-hover energia-lista-table"
              head-variant="light"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :current-page="currentPage"
              :per-page="perPage"
              responsive
              show-empty
              empty-text="Nenhum cliente encontrado"
              @row-clicked="onRowClienteClick"
            >
              <template #cell(name)="row">
                <span style="line-height: 18px;">
                  {{ row.item.name }}<br>
                  {{ formatCpfCnpjDisplay(row.item.person_number) || '—' }}
                </span>
              </template>
              <template #cell(date_added)="row">
                {{ formatDateBR(row.item.date_added) || '—' }}
              </template>
              <template #cell(status)="row">
                <StatusBadge :status="row.item.display_status || row.item.status" />
              </template>
              <template #cell(acoes)="row">
                <router-link
                  :to="'/energia/clientes/' + row.item.id"
                  class="btn btn-sm btn-default"
                  @click.native.stop
                >
                  Ver
                </router-link>
              </template>
            </b-table>
          </div>
          <b-pagination
            v-if="clientesFiltrados.length > perPage"
            v-model="currentPage"
            :total-rows="clientesFiltrados.length"
            :per-page="perPage"
            pills
            align="center"
            class="mt-3 mb-0"
          />
        </div>
      </div>
    </div>
  </Layout>
</template>
